export default "__VITE_PUBLIC_ASSET__038d78b7__"